module.exports = __webpack_public_path__ + "img/5.e65c3caf.jpg";